import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
export function ContactForm() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you for your inquiry! Our sales team will contact you within 24 hours.');
      setFormState({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-20 bg-[#4B280B] text-white" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-39">
          {/* Contact Info */}
          <div data-id="element-40">
            <h2 className="text-[#d4af37] font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-41">
              Get In Touch
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-42">
              Start Your Wholesale Journey
            </h3>
            <p className="text-gray-300 text-lg mb-10" data-id="element-43">
              Ready to scale your hair business? Fill out the form to get our
              latest wholesale price list and discuss your specific
              requirements.
            </p>

            <div className="space-y-8" data-id="element-44">
              <div className="flex items-start gap-4" data-id="element-45">
                <div className="p-3 bg-[#5a2205] rounded-lg text-[#7E3007]" data-id="element-46">
                  <Phone className="w-6 h-6" data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <h4 className="font-semibold text-lg" data-id="element-49">WhatsApp / Phone</h4>
                  <p className="text-blue-200" data-id="element-50">+84 86 981 2254</p>
                  <p className="text-xs text-blue-300 mt-1" data-id="element-51">
                    Available 24/7 for support
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-52">
                <div className="p-3 bg-[#5a2205] rounded-lg text-[#7E3007]" data-id="element-53">
                  <Mail className="w-6 h-6" data-id="element-54" />
                </div>
                <div data-id="element-55">
                  <h4 className="font-semibold text-lg" data-id="element-56">Email</h4>
                  <p className="text-gray-300" data-id="element-57">
                    luxhairwholesalefactory@gmail.com
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-58">
                <div className="p-3 bg-[#5a2205] rounded-lg text-[#7E3007]" data-id="element-59">
                  <MapPin className="w-6 h-6" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <h4 className="font-semibold text-lg" data-id="element-62">Factory Location</h4>
                  <p className="text-blue-200" data-id="element-63">
                    Khanh Van,
                    <br data-id="element-64" />
                    Bac Giang Province, Vietnam
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-65">
                <div className="p-3 bg-[#5a2205] rounded-lg text-[#7E3007]" data-id="element-66">
                  <MapPin className="w-6 h-6" data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="font-semibold text-lg" data-id="element-69">Office Location</h4>
                  <p className="text-blue-200" data-id="element-70">
                    310 Nghi Tam Lane, Yen Phu Street,
                    <br data-id="element-71" />
                    Hong Ha Ward, Hanoi, Vietnam
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl p-8 text-gray-900 shadow-2xl" data-id="element-72">
            <h3 className="text-2xl font-bold mb-6" data-id="element-73">Send Inquiry</h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-74">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-75">
                <div data-id="element-76">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-77">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#7E3007] focus:border-transparent outline-none transition-all" placeholder="John Doe" data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-80">
                    WhatsApp Number
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#d4af37] focus:border-transparent outline-none transition-all" placeholder="+1 234 567 8900" data-id="element-81" />
                </div>
              </div>

              <div data-id="element-82">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-83">
                  Email Address
                </label>
                <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#d4af37] focus:border-transparent outline-none transition-all" placeholder="john@company.com" data-id="element-84" />
              </div>

              <div data-id="element-85">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-86">
                  Company / Brand Name
                </label>
                <input type="text" id="company" name="company" value={formState.company} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#d4af37] focus:border-transparent outline-none transition-all" placeholder="Your Hair Brand" data-id="element-87" />
              </div>

              <div data-id="element-88">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-89">
                  Message / Requirements
                </label>
                <textarea id="message" name="message" rows={4} required value={formState.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#d4af37] focus:border-transparent outline-none transition-all resize-none" placeholder="I'm interested in wholesale pricing for bone straight hair..." data-id="element-90"></textarea>
              </div>

              <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} className="mt-2" data-id="element-91">
                Send Inquiry <Send className="ml-2 w-4 h-4" data-id="element-92" />
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}